/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611041809-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * Per-column row filters applied to the materialized capsule rows before sort and paging. Filters are AND-combined across entries.
 */
export interface CapsulesTableFilterV1 {
    /**
     * Header name of the column to filter against.
     */
    "column": string;
    /**
     * Predicate name from the formula PREDICATE_API set: isLessThan, isLessThanOrEqualTo, isGreaterThan, isGreaterThanOrEqualTo, isEqualTo, isNotEqualTo, isBetween, isNotBetween, isMatch, isNotMatch.
     */
    "operator": OperatorEnum;
    /**
     * When true, treat `values` as the set of selected matches.
     */
    "usingSelectedValues"?: boolean;
    /**
     * Operand values for the predicate. For `isBetween`/`isNotBetween` supply [low, high]. String match predicates interpret operands according to the filter mode.
     */
    "values"?: Array<any>;
}

export const OperatorEnum = {
    IsLessThan: 'isLessThan',
    IsLessThanOrEqualTo: 'isLessThanOrEqualTo',
    IsGreaterThan: 'isGreaterThan',
    IsGreaterThanOrEqualTo: 'isGreaterThanOrEqualTo',
    IsEqualTo: 'isEqualTo',
    IsNotEqualTo: 'isNotEqualTo',
    IsBetween: 'isBetween',
    IsNotBetween: 'isNotBetween',
    IsMatch: 'isMatch',
    IsNotMatch: 'isNotMatch'
} as const;

export type OperatorEnum = typeof OperatorEnum[keyof typeof OperatorEnum];
